import { BankIdLoginContainer } from '../../containers/bank-id-login-container';
import { UsernameLoginContainer } from '../../containers/username-login-container';
import { getPortalBaseUrlForCurrentHost } from '../../utils/iam-login-url';
import { WelcomeBackground } from '../welcome-background';
import './styles.less';
const {
  RedirectToReturnUrl
} = svs.retailUtils;
const {
  Redirect,
  Route,
  Switch
} = ReactRouterDOM;
const {
  ReactIcon: Icon
} = svs.ui;
const {
  Dialog
} = svs.retailUi;
export const Login = ({
  error,
  hasToChangePassword,
  hasMissingUserMetadata,
  isComplete,
  onCloseErrorDialog,
  onCloseMetadataErrorDialog
}) => {
  const isIamIdpModule = svs.core?.data?.module === 'iam-idp';
  const loginBasePath = isIamIdpModule ? '' : '/logga-in';
  const bankIdPath = `${loginBasePath}/bank-id`;
  const usernamePath = `${loginBasePath}/anvandarnamn`;
  const bankIdPaths = isIamIdpModule ? ['/bank-id', '/logga-in/bank-id'] : [bankIdPath];
  const usernamePaths = isIamIdpModule ? ['/anvandarnamn', '/logga-in/anvandarnamn'] : [usernamePath];
  return <WelcomeBackground className="login-component padding-top-2 padding-bottom-4" isDark>
      {isComplete && !hasToChangePassword && <RedirectToReturnUrl />}
      {!isComplete && hasMissingUserMetadata && <Dialog buttonCallback={onCloseMetadataErrorDialog} buttonTitle="Okej" icon="exclamation-sign" message="Det gick inte att hämta all information om ditt konto. Viss funktionalitet kommer inte vara tillgänglig." title="Någonting gick fel" />}

      {error && <Dialog buttonCallback={onCloseErrorDialog} buttonTitle="Okej" icon={error.icon} message={error.message} severe={error.severe} title={error.title} type={error.type} />}

      <div className="login-back-link-wrapper">
        <a href={getPortalBaseUrlForCurrentHost()}>
          <Icon color="fc-white" icon="arrow-left" size="100" />
          {' '}
          Välj annat inloggningssätt
        </a>
      </div>

      <Switch>
        <Route component={BankIdLoginContainer} path={bankIdPaths} />
        <Route component={UsernameLoginContainer} path={usernamePaths} />
        <Redirect to={{
        pathname: bankIdPath,
        search: window.location.search
      }} />
      </Switch>
    </WelcomeBackground>;
};